module.exports = __webpack_public_path__ + "129daf4bc5916332351e576f89557112.svg";